<template>
  <section class="customer-wrap">
    <h2 class="ta-c">Customer Stories</h2>
    <ul class="d-f jc-c blog-mod">
      <li v-for="(item, index) in customerData" :key="index">
        <div class="img-box">
          <img
            class="lazy-image"
            v-lazy="item.imgUrl"
            data-original=".."
            width="100%"
            height=""
            alt="Missouri and Arkansas, USA"
          />
          <i
            @click="playVideo(index)"
            class="play-icon play-icon-fff d-b p-a c-c z-3 c-p"
            data-v-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/8cabd39a387702298435663453/3W2yiAfLkV4A.mp4"
          ></i>
        </div>
        <div class="text-box">
          <h3>{{ item.h2 }}</h3>
          <hr />
          <div class="desc ellipsis wlc-5">
            {{ item.desc }}
          </div>
        </div>
      </li>
    </ul>
    <Modal
      v-model="modal10"
      footer-hide
      :scrollable="false"
      width="60"
      :lock-scroll="false"
      class-name="vertical-center-modal"
    >
      <div slot="close">
        <svg-icon icon-class="video-close-white" class-name="close"></svg-icon>
      </div>

      <video
        v-if="isCloud"
        class="lazy-video"
        width="100%"
        height="100%"
        style="object-fit: none"
        x5-playsinline
        x5-video-player-type="h5"
        x-webkit-airplay="allow"
        playsinline
        webkit-playsinline
        muted
        loop
        autoplay
        controls
        :src="videoUrl"
      ></video>
      <iframe
        v-else
        width="100%"
        height="100%"
        :src="videoUrl"
        frameborder="0"
        allow="autoplay"
        allowfullscreen=""
      ></iframe>
    </Modal>
  </section>
</template>

<script>
  export default {
    props: {
      customerData: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        modal10: false,
        videoUrl: '',
        isCloud: true // 是否云点播链接
      }
    },
    created() {},
    mounted() {},
    methods: {
      playVideo(idx) {
        this.videoUrl = this.customerData[idx].videoUrl

        this.isCloud = !this.videoUrl.includes('youtube.com')

        this.modal10 = true
      }
    }
  }
</script>

<style scoped lang="scss">
  .customer-wrap {
    margin-bottom: 1.6rem;
  }
  .customer-wrap h2 {
    font-size: 0.48rem;
    font-weight: 700;
    margin-bottom: 0.32rem;
  }
  .customer-wrap li .img-box::after {
    display: block;
    content: '';
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.3);
    top: 0;
    left: 0;
    position: absolute;
  }
  .blog-mod li {
    width: 4.4rem;
    margin-left: 0.16rem;
    box-sizing: border-box;
    border: 1px solid #e5e5e5;
  }
  .blog-mod li:nth-of-type(1) {
    margin-left: 0;
  }
  .blog-mod li .img-box {
    height: 2.48rem;
    position: relative;
    overflow: hidden;
  }
  .blog-mod li .img-box a {
    display: block;
    height: 100%;
  }
  .blog-mod li .img-box img {
    transition: transform 0.2s linear;
  }
  .blog-mod li .img-box:hover img {
    transform: scale(1.1);
  }
  .blog-mod li hr {
    border: none;
    border-top: 1px solid #999999;
    width: 0.6rem;
    margin: 0.24rem 0;
  }
  .blog-mod li .text-box {
    height: 2.35rem;
    padding: 0 0.24rem;
    border-top: none;
    font-size: 0.16rem;
    overflow: hidden;
  }
  .blog-mod li .desc {
    color: #999;
  }
  .blog-mod li h3 {
    padding-top: 0.24rem;
    font-size: 0.2rem;
    color: #333;
    font-weight: 500;
  }
  :deep(.vertical-center-modal) {
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal {
      top: 0;
    }
  }
  :deep(.ivu-modal-body) {
    padding: 0;
    height: 70vh;
  }
  :deep(.ivu-modal-content) {
    background: #000;
    box-sizing: border-box;
    // overflow: hidden;
  }
  :deep(.ivu-modal-close) {
    top: -30px;
    right: -30px;
  }
  .close {
    width: 30px;
    height: 30px;
  }
</style>
